import { motion } from "framer-motion";

const participants = [
  { id: "P1", age: 34, experience: "2 YRS", location: "SAN JOSE/CALIFORNIA" },
  { id: "P2", age: 45, experience: "5 YRS", location: "FRANKFORT/KENTUCKY" },
  {
    id: "P3",
    age: 30,
    experience: "6 MONTHS",
    location: "HARTFORD/CONNECTICUT",
  },
  { id: "P4", age: 28, experience: "2 YRS", location: "DALLAS/TEXAS" },
  { id: "P5", age: 32, experience: "3 YRS", location: "BUSHWICK/NYC" },
  {
    id: "P6",
    age: 41,
    experience: "LESS THAN A YEAR",
    location: "PITTSBURGH/PA",
  },
];

export function DemographicsTable() {
  return (
    <div
      className="rounded-2xl item-border border-white/10 bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm p-6 md:p-8"
    >
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
        className="text-center text-[#D4B896] text-sm mb-6"
      >
        Participants: 06 Members
      </motion.p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#D4B896] text-black">
              <th className="text-left px-3 py-3 font-bold rounded-tl-xl">
                PARTICIPANTS
              </th>
              <th className="text-center px-3 py-3 font-bold">AGE</th>
              <th className="text-left px-3 py-3 font-bold">EXPERIENCE</th>
              <th className="text-left px-3 py-3 font-bold rounded-tr-xl">
                LOCATION
              </th>
            </tr>
          </thead>
          <tbody>
            {participants.map((participant, index) => (
              <motion.tr
                key={participant.id}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="border-b border-white/10"
              >
                <td className="bg-[#D4B8964D] text-white px-3 py-3 font-normal">
                  {participant.id}
                </td>
                <td className="bg-white/5 text-research-gray px-3 py-3 text-center">
                  {participant.age}
                </td>
                <td className="bg-white/5 text-research-gray px-3 py-3">
                  {participant.experience}
                </td>
                <td className="bg-white/5 text-research-gray px-3 py-3">
                  {participant.location}
                </td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
